<template>
  <div
    class="
      mx-auto
      w-full
      bg-brand-background-light-yellow
      border-2 border-brand-yellow
      rounded
      alert-toast
    "
  >
    <slot></slot>
  </div>
</template>
